import React, { useEffect, useState } from 'react';
import { Slider } from 'antd';
import moment from "moment";

function TimeRangeSlider(props) {
    const initMins = props.initialMinutes != null ? props.initialMinutes : 0
    const [rangeValue, setRangeValue] = useState([0, initMins]);
    const [totalTime, setTotalTime] = useState(initMins)
    const [maxTime, setMaxTime] = useState(1440)

    useEffect(() => {
        props.setFleetTimeRange([valueToTimeString(rangeValue[0]), valueToTimeString(rangeValue[1])])
    }, [rangeValue]);

    // Convert slider value to time string
    const valueToTimeString = (value) => {
        const hours = Math.floor(value / 60); // Each hour has 4 steps of 15 minutes
        const minutes = (value % 60);
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    };

    const handleRangeChange = (v) => {
        const value = [0, v]
        setRangeValue(value);
        setTotalTime(Number(value[1] || 0) - Number(value[0] || 0))
        props.setTotalTimerange(Number(value[1] || 0) - Number(value[0] || 0))
        // console.log(value)
    };

    useEffect(() => {
        if (props.selectedDate)
            checkIfToday(props.selectedDate);
    }, [props.selectedDate]);

    const checkIfToday = (date) => {
        const today = moment();
        if (date.isSame(today, 'day')) {
            const currentTimeInMinutes = today.hours() * 60 + today.minutes();
            setMaxTime(currentTimeInMinutes);
            // Clamp the slider position — covers the pre-fill case where initMins
            // may be larger than current time (or == current time is also fine)
            setRangeValue(prev => [prev[0], Math.min(prev[1], currentTimeInMinutes)]);
        } else {
            setMaxTime(1440);
        }
    };
    return (
        <div style={{ width: '100%', margin: '10px auto' }}>
            <Slider

                min={0}
                max={maxTime} // 24 hours * 60 minutes - 1
                step={1}
                marks={{
                    0: '00:00',
                    // 360: '06:00',
                    // 720: '12:00',
                    // 1080: '18:00',
                    [Math.round(maxTime / 2)]: valueToTimeString(Math.round(maxTime / 2)),
                    [maxTime]: valueToTimeString(maxTime)
                }}
                tipFormatter={valueToTimeString}
                onChange={handleRangeChange}
                value={rangeValue[1]}
            />
            {/* <div style={{ marginTop: 20, textAlign: 'center' }}>
                Selected Time Range: {valueToTimeString(rangeValue[0])} - {valueToTimeString(rangeValue[1])}
            </div>
            <div style={{ marginTop: 0, textAlign: 'center' }}>Total : {valueToTimeString(totalTime)}
            </div> */}
        </div>
    );
}

export default TimeRangeSlider;
